import React from 'react';

const StartGame = ({setPlay, authUser, jwtData}) => {
    return <div className={"startPlay"}>
        <div className="playBtn-wrapper">
            <div className={"playBtn"} onClick={() => {
                const loggedIn = !!authUser || (jwtData != null && jwtData.hasOwnProperty("email"))
                if (!loggedIn) {
                    window.dispatchEvent(new CustomEvent('onShowLoginEvent'));
                } else {
                    setPlay(true)
                }
            }}></div>
        </div>
    </div>
}

export default StartGame
